import { UnknownAction } from '@reduxjs/toolkit';
import { REHYDRATE } from 'redux-persist';

const extractRehydrationInfo = (
  action: UnknownAction,
  { reducerPath }: { reducerPath: string }
) => {
  if (action.type !== REHYDRATE) {
    return undefined;
  }

  const payload = (action as { payload?: Record<string, unknown> }).payload;
  return payload?.[reducerPath] as any;
};

export default extractRehydrationInfo;
